import { Calendar } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Link } from 'react-router-dom';

export default function FloatingBookingButton() {
  const { t } = useLanguage();

  return (
    <Link
      to="/booking"
      aria-label={t('checkAvailability')}
      className="fixed bottom-8 right-8 z-40 bg-accent text-accent-foreground px-6 py-3.5 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center gap-2.5 font-sans text-sm font-medium tracking-wide max-sm:bottom-3 max-sm:right-3 max-sm:px-3.5 max-sm:py-2 max-sm:text-xs max-sm:gap-1.5"
    >
      <Calendar size={18} aria-hidden="true" />
      {t('checkAvailability')}
    </Link>
  );
}
